"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var polished_1 = require("polished");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importStar(require("../../../theme/styled-components"));

var _utilities_1 = require("../../../utilities");

var WrapperStyles = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  align-items: center;\n"])));
var AWrapper = styled_components_1["default"].a(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  text-decoration: none;\n  cursor: pointer;\n"], ["\n  ", "\n  text-decoration: none;\n  cursor: pointer;\n"])), WrapperStyles);
var Wrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), WrapperStyles);
var BackDrop = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n"])));
var Title = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  color: #fff;\n  font-weight: bold;\n  font-size: ", ";\n  user-select: none;\n  margin: auto 0;\n  padding: ", ";\n  max-width: 100%;\n"], ["\n  color: #fff;\n  font-weight: bold;\n  font-size: ", ";\n  user-select: none;\n  margin: auto 0;\n  padding: ", ";\n  max-width: 100%;\n"])), polished_1.em(28), polished_1.rem(20));
var TitleWrapper = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n"])));
var FullWidthMediaManagerImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));

var ImageAd = function (_a) {
  var _b = _a.data,
      data = _b === void 0 ? {} : _b,
      renderEmpty = _a.renderEmpty,
      theme = _a.theme;
  var inValid = !data.uri && !data.media_url;

  if (inValid && renderEmpty) {
    return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('imagead'));
  }

  if (inValid) {
    return null;
  }

  var content = react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(FullWidthMediaManagerImage, {
    picture: data,
    naturalWidth: _utilities_1.getMaxContentWidthFromTheme(theme),
    naturalHeight: 0
  }), data.name && react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(BackDrop, null), react_1["default"].createElement(TitleWrapper, null, react_1["default"].createElement(Title, null, data.name))));

  if (data.target) {
    return react_1["default"].createElement(AWrapper, {
      href: data.target,
      title: data.name
    }, content);
  }

  return react_1["default"].createElement(Wrapper, null, content);
};

exports["default"] = styled_components_1.withTheme(ImageAd);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;